import Vue from 'vue';
import axios from 'axios';
import '../../filters';
import moment from 'moment';
import { date } from 'devexpress-dashboard/model/index.metadata';


export default {
  name: 'conditionAssessment',
  components: {
    ElementsSearch: require('../assetsSubComponents/elementsSearch/elementsSearch.vue').default,
    ElementProperties: require('../assetsSubComponents/elementProperties/elementProperties.vue').default,
    TreeSelect: require('../../customcontrols/selectOfTree.vue').default,
    ManageAssessment: require('../assetsSubComponents/manageAssessment/manageAssessment.vue').default,
  },
  data: function () {
    return {
      isReadOnly: false,
      thisPage: null,
      elementTypeId: 0,
      elementId: 0,
      entitySubId: -1,
      lookupsSource: {},
      lookups: {},
      assetsElement: {
        assessments: [],
        lastAssessment: null
      },
      currentTab: 'tab-latestAssessment',
      assessmentDialogShow: false,
      assessmentDate: null,
      propertiesDialogShow: false,
      deleteAssessmentConfirmationDialogShow: false,
      assessmentForDelete: null,
      deleteMessage: '',
      isNewConditionAssessm: false,
      elementConditions: [],
      elementRating: ''
    }
  },
  computed: {

  },
  watch: {
    //currentTab: {
    //  handler: function (val, oldVal) {
    //    if (val == 'tab-properties') {
    //      this.$nextTick(() => {
    //        this.currentTab = oldVal;
    //      })
    //    }
    //  }
    //},
  },
  created() {
    this.$root.$on('selected_element_chosen', (data) => this.getSelectedElement(data.elementTypeId, data.elementId));
    this.thisPage = this;
    this.$material.locale.dateFormat = 'yyyy-MM-dd';

    this.getAssessmentLookups();
  },
  methods: {
    getAssessmentLookups() {
      axios.get('/ConditionAssessment/GetLookups')
        .then(response => {
          if (response.status == 200) {
            this.lookups = response.data;
            if (this.lookups.additionalComments && this.lookups.additionalComments.length > 0)
              this.lookups.additionalComments = this.fillLookUpList(this.lookups.additionalComments, 'value', 'text');

            if (this.lookups.maintenanceEfforts && this.lookups.maintenanceEfforts.length > 0)
              this.lookups.maintenanceEfforts = this.fillLookUpList(this.lookups.maintenanceEfforts, 'id', 'displayString');

            if (this.lookups.projects && this.lookups.projects.length > 0)
              this.lookups.projects = this.fillLookUpList(this.lookups.projects, 'id', 'displayString');

            if (this.lookups.urgencies && this.lookups.urgencies.length > 0)
              this.lookups.urgencies = this.fillLookUpList(this.lookups.urgencies, 'value', 'text');

            if (this.lookups.importance && this.lookups.importance.length > 0)
              this.lookups.importance = this.fillLookUpList(this.lookups.importance, 'value', 'text');

            if (this.lookups.requiredMeasures && this.lookups.requiredMeasures.length > 0)
              this.lookups.requiredMeasures = this.fillLookUpList(this.lookups.requiredMeasures, 'value', 'text');

            if (this.lookups.inspectionMethods && this.lookups.inspectionMethods.length > 0)
              this.lookups.inspectionMethods = this.fillLookUpList(this.lookups.inspectionMethods, 'value', 'text');

            if (this.lookups.purposes && this.lookups.purposes.length > 0)
              this.lookups.purposes = this.fillLookUpList(this.lookups.purposes, 'value', 'text');

            if (this.lookups.types && this.lookups.types.length > 0)
              this.lookups.types = this.fillLookUpList(this.lookups.types, 'value', 'text');

            if (this.lookups.evaluations && this.lookups.evaluations.length > 0)
              this.lookups.evaluations = this.fillLookUpList(this.lookups.evaluations, 'value', 'text');

            //console.log("lookups",this.lookups);
          }
        }).catch(error => {
          this.$alertMsg(error);
        });
    },
    getElementTypeConditions() {
      this.elementConditions = [];
      this.elementRating = '';

      var parameters = {
        value: this.elementTypeId
      };

      axios.post('/Om/GetElementTypeConditions', parameters)
        .then(response => {
          if (response.status == 200) {
            this.elementConditions = response.data.items;

            if (this.elementConditions.length > 0) {
              if (this.elementConditions.filter(a => a.conditionId == this.assetsElement.lastAssessment.conditionId).length > 0) {
                this.elementRating = this.elementConditions.filter(a => a.conditionId == this.assetsElement.lastAssessment.conditionId)[0].name;
              }
            }
          }
        }).catch(error => {
          this.$alertMsg(error);
        });
    },
    fillLookUpList(list, idField, labelField) {
      var selectList = [];

      var item = {};

      for (var i = 0; i < list.length; i++) {
        item = list[i];

        item['id'] = item[idField];
        if (idField != 'id')
          delete item[idField];

        item['label'] = item[labelField];
        if (labelField != 'label')
          delete item[labelField];

        selectList.push(item);
      }

      return selectList;
    },
    getSelectedElement(elementTypeId, elementId) {
      this.elementTypeId = elementTypeId;
      this.elementId = elementId;

      this.getAssetElement();
    },
    getAssetElement(stayOnTab) {
      if (this.elementTypeId <= 0 || this.elementId <= 0 || this.elementId == null || this.elementTypeId == null)
        return;

      this.$store.state.notifier.asyncBlock(
        axios.get('/ConditionAssessment/GetList', { params: { elementTypeId: this.elementTypeId, elementId: this.elementId } } ),
        response => {
          if (response.status == 200) {
            if (!stayOnTab)
              this.currentTab = 'tab-latestAssessment';

            this.assetsElement.assessments = response.data;
            this.assetsElement.assessments.forEach(a => {
              a['dateForDelete'] = a.date;
            });

            if (response.data.length > 0) {
              this.assetsElement.lastAssessment = response.data[response.data.length - 1];

              this.assetsElement.lastAssessment.conditionDate = moment(this.assetsElement.lastAssessment.date).format('YYYY-MM-DD hh:mm');
              
              this.getElementTypeConditions();
            } else {
              this.assetsElement.lastAssessment = null;
              //this.$alertMsg('No records found');
            }
          }
        },
        error => {
          this.$alertMsg(error.response.data);
        }
      );
    },
    changeTab(e) {
      //if (e == 'tab-properties') {
      //  this.propertiesDialogShow = true;
      //}

      this.currentTab = e;
    },
    deleteAssessmentConfrirm(p) {
      this.assessmentForDelete = p;
      this.deleteMessage = this.$t('assets.deleteAssessmentMessage') + '<strong>' + moment(this.assessmentForDelete.conditionDate).format('DD/MM/YYYY HH:mm') + '</strong> ?'
      this.deleteAssessmentConfirmationDialogShow = true;
    },
    deleteAssessment() {
      let param = {
        ElementTypeId:  this.assessmentForDelete.elementTypeId,
        ElementId: this.assessmentForDelete.elementId,
        Date: this.assessmentForDelete.dateForDelete,
      }

      this.$store.state.notifier.asyncBlock(
        axios.post('/ConditionAssessment/Delete', param ),
        response => {
          if (response.status == 200) {
            this.assetsElement.assessments.splice(this.assetsElement.assessments.indexOf(this.assessmentForDelete), 1);
            this.$alertMsg(this.$t('assets.assessmentHasBeenDeletedSuccessfully'), 2);
            this.getAssetElement(true);
          }
        },
        error => {
          this.$alertMsg(error.response.data);
        },
        this.$t('common.deleting')
      );
    },
    openAssesment(assessment) {
      this.assessmentDate = assessment.date;
      this.entitySubId = assessment.entitySubId;
      this.isNewConditionAssessm = false;
      this.assessmentDialogShow = true;

      this.isReadOnly = this.isAssessmentReadOnly(assessment);
    },
    isAssessmentReadOnly(assessment) {
      let flag = false;

      for (let key in assessment) {
        if (assessment[key] == null || this.assetsElement.lastAssessment[key] == null || assessment[key] != this.assetsElement.lastAssessment[key])
          flag = false;
      }

      return flag;
    },
    addNewConditionAssessment() {
      this.assessmentDate = moment().format('YYYY-MM-DDTHH:mm:ss');
      this.isReadOnly = false;
      this.isNewConditionAssessm = true;
      this.assessmentDialogShow = true;
      this.viewAssessment = false;
    },
    clearData() {
      this.elementTypeId = 0;
      this.elementId = 0;

      this.assetsElement = {
        assessments: [],
        lastAssessment: null
      };
    },
    refreshAfterInsertAssessment(val) {
      if (val == 'refresh')
        this.getAssetElement();

      this.entitySubId = -1;
      this.assessmentDialogShow = false;
    }
  },
}
